import React from "react";
import { useSelector } from "react-redux";
import { selectUsedTheme } from "_redux/slices/timeline/theme";

const TimelineContentContainer = (props) => {
  const usedTheme = useSelector(selectUsedTheme);

  return (
    <>
      {/* Scoped scrollbar CSS - applies ONLY to .timeline-scrollbar */}
      <style>
        {`
          .timeline-scrollbar::-webkit-scrollbar {
            width: 18px;    /* vertical scrollbar width */
            height: 18px;   /* horizontal scrollbar height */
          }

          .timeline-scrollbar::-webkit-scrollbar-track {
            background: ${usedTheme.BACKGROUND_COLOR || "#e0e0e0"};
          }

          .timeline-scrollbar::-webkit-scrollbar-thumb {
            background: ${usedTheme.PRIMARY_COLOR || "#999"};
            border-radius: 8px;
            border: 3px solid ${usedTheme.BACKGROUND_COLOR || "#e0e0e0"};
          }

          .timeline-scrollbar::-webkit-scrollbar-thumb:hover {
            background: ${usedTheme.PRIMARY_COLOR_HIGHLIGHT || "#777"};
          }
        `}
      </style>

      <div
        ref={props.devRef}
        onScroll={props.onDevScroll}
        className="timeline-scrollbar"
        style={{
          flex: 1,
          minHeight: 0,
          height: "100%",
          display: "block",

          /* Enable BOTH horizontal & vertical scrollbars */
          overflowX: "scroll",
          overflowY: "scroll",

          /* Keep scrollbars permanently visible */
          scrollbarGutter: "stable",

          /* Firefox scrollbar fallback */
          scrollbarWidth: "auto",
          scrollbarColor: `${usedTheme.PRIMARY_COLOR} ${usedTheme.BACKGROUND_COLOR}`,

          width: "100%",
        }}
      >
        {props.children}
      </div>
    </>
  );
};

export default TimelineContentContainer;
